
const validateEmail = (email)  => {   
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email.toLowerCase());
}

export default function validate(values, fieldName) {
    let errors = {};
    // email
    if(fieldName === 'email' || fieldName === 'emailAddress' || fieldName === undefined){        
        if(values[fieldName] && !validateEmail(values[fieldName])){         
            errors.email = 'Value must be a valid email address';
        }
    }

    // first name
    if(fieldName === 'firstname' || fieldName === undefined){
        if(!values[fieldName]){
            errors.firstname = 'First Name is reqired';
        }
    }

    // last name
    if(fieldName === 'lastname' || fieldName === undefined){
        if(!values[fieldName]){
            errors.lastname = 'Last Name is reqired';
        }
    }    
    return errors;
}